export default __webpack_public_path__ + "static/media/meh.08bdd297.svg";